import {
    STAKEHOLDER_ITEM_RESPONSE,
    STAKEHOLDER_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"
import { normalise } from "../../models/entities/user"

export default (state = {}, action) => {
    const { type, receivedAt, data } = action
    switch (type) {
        case STAKEHOLDER_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case STAKEHOLDER_ITEM_RESPONSE: {
            const { id } = data

            const { photo_url, ...newData } = data

            return {
                ...state,
                [id]: {
                    ...state[id],
                    ...normalise(newData),
                    lastUpdatedAt: receivedAt
                }
            }
        }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
